export const TUTOR_STATUS_OPTIONS = ["Active", "On Hold", "Finished"];

export function normalizeStatus(raw) {
  const s = String(raw ?? "active").trim().toLowerCase();
  if (s === "active") return "Active";
  if (s === "on hold" || s === "hold" || s === "onhold") return "On Hold";
  if (s === "finished") return "Finished";
  return "Active";
}

export const UI = {
  shell: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",              // ✅ prevents body scroll (no double-scroll)
    background: "#f3f4f6",
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
  },

// --- UPDATED UI SECTIONS IN tutorStyles.js ---

  headerBar: {
    height: "64px",
    backgroundColor: "#111827",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 24px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    zIndex: 10,
    position: "sticky",
    top: 0,
  },

  // ✅ NEW: main becomes the scroll container (full width -> scrollbar at far right)
  page: {
    flex: 1,
    width: "100%",
    overflowY: "auto",
    overflowX: "auto",               // keep if Saturday gets wide
    padding: "18px",
    boxSizing: "border-box",
  },

  // ✅ NEW: keep your content centered, but NOT the scroll container
  pageInner: {
    maxWidth: 1200,
    margin: "0 auto",
  },

  brand: { 
    fontWeight: 700, 
    fontSize: "18px", 
    letterSpacing: "0.5px" 
  },

  navRow: { 
    display: "flex", 
    gap: "8px", 
    height: "100%", 
    alignItems: "stretch" // Important for the bottom border to hit the base
  },

  tab: (active, disabled) => ({
    display: "flex",
    alignItems: "center",
    padding: "0 16px",
    cursor: disabled ? "not-allowed" : "pointer",
    fontSize: "14px",
    fontWeight: active ? 600 : 500,
    color: active ? "#ffffff" : disabled ? "#4b5563" : "#9ca3af",
    borderBottom: active ? "3px solid #3b82f6" : "3px solid transparent",
    transition: "all 0.2s",
    height: "100%",
    boxSizing: "border-box",
    userSelect: "none",
  }),

  logout: {
    backgroundColor: "#dc2626", // Matches Admin Red
    color: "white",
    border: "none",
    padding: "8px 16px",
    borderRadius: "6px",
    fontWeight: 600,
    fontSize: "13px",
    cursor: "pointer",
    transition: "background 0.2s",
  },

  card: {
    background: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: 18,
    boxShadow: "0 8px 30px rgba(15, 23, 42, 0.05)",
    overflow: "hidden",
  },

  cardHeader: {
    padding: "16px 16px",
    borderBottom: "1px solid #eef2f7",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
  },

  title: { fontSize: 18, fontWeight: 950, color: "#0f172a" },
  subtitle: { fontSize: 12, fontWeight: 900, color: "#64748b", marginTop: 6 },

  btn: (variant) => ({
    padding: "10px 14px",
    borderRadius: 12,
    border: "1px solid #e2e8f0",
    background: variant === "primary" ? "#2563eb" : "#fff",
    color: variant === "primary" ? "#fff" : "#0f172a",
    fontWeight: 950,
    cursor: "pointer",
  }),

  content: { padding: 16 },

  label: { fontSize: 12, fontWeight: 950, color: "#0f172a", marginBottom: 6 },
  input: {
    width: "100%",
    padding: "10px 12px",
    borderRadius: 12,
    border: "1px solid #e2e8f0",
    background: "#fff",
    outline: "none",
    fontWeight: 900,
    color: "#0f172a",
  },
  inputDisabled: {
    background: "#f8fafc",
    color: "#64748b",
    cursor: "not-allowed",
  },
  select: {
    width: "100%",
    padding: "10px 12px",
    borderRadius: 12,
    border: "1px solid #e2e8f0",
    background: "#fff",
    fontWeight: 900,
    color: "#0f172a",
    outline: "none",
  },

  badgePill: (label) => {
    const map = {
      Active: { bg: "#dcfce7", fg: "#166534", bd: "#86efac" },
      "On Hold": { bg: "#fef9c3", fg: "#854d0e", bd: "#fde68a" },
      Finished: { bg: "#fee2e2", fg: "#991b1b", bd: "#fecaca" },
    };
    const s = map[label] || map.Active;
    return {
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      padding: "6px 10px",
      borderRadius: 999,
      border: `1px solid ${s.bd}`,
      background: s.bg,
      color: s.fg,
      fontWeight: 950,
      fontSize: 12,
      width: "fit-content",
    };
  },

  chipRow: { display: "flex", gap: 8, flexWrap: "wrap", marginTop: 10 },
  chip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "7px 10px",
    borderRadius: 999,
    border: "1px solid #e2e8f0",
    background: "#fff",
    fontWeight: 900,
    color: "#0f172a",
    fontSize: 13,
  },

  noteBox: {
    border: "1px solid #f59e0b",
    background: "#fff7ed",
    borderRadius: 14,
    padding: 10,
  },
  noteTextArea: {
    width: "100%",
    border: "none",
    outline: "none",
    resize: "none",
    background: "transparent",
    fontWeight: 900,
    color: "#0f172a",
    fontSize: 14,
    lineHeight: 1.4,
  },
};
